export default __webpack_public_path__ + "static/media/benefits_sipbooster_investmenticon.bc4ac692.svg";